var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],staticClass:"tp-input",class:_vm.inputClass,attrs:{"placeholder":_vm.placeholder,"type":_vm.type},domProps:{"value":_vm.modelValue},on:{"input":_vm.updateValue,"blur":_vm.handleBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }